export const checkIfUserPhoneExists = async (axiosInstance, phoneNumber) => {
  try {
    const response = await axiosInstance.post('/user/phoneNumberCheck', {
      phoneNumber: phoneNumber,
    });
    if (response.status === 201) {
      // Sync lockUntil from DB
      if (response.data?.lockUntil) {
        localStorage.setItem('lockUntil', response.data.lockUntil);
      } else {
        localStorage.removeItem('lockUntil');
      }
      return {
        success: true,
        lockUntil: response.data?.lockUntil || null,
      };
    } else if (response.status === 200) {
      localStorage.removeItem('lockUntil');
      return {
        success: false,
      };
    }
  } catch (error) {
    console.log(error);
    return {
      serverError: 'Veuillez réessayer plus tard',
    };
  }
};

export const changePassword = async (
  axiosInstance,
  phoneNumber,
  password,
  setlockUntil,
) => {
  try {
    const response = await axiosInstance.post('/user/changePassword', {
      phoneNumber: phoneNumber,
      newPassword: password,
    });
    if (response.status === 201) {
      if (localStorage.getItem('lockUntil')) {
        localStorage.removeItem('lockUntil');
      }
      setlockUntil(false);
      return {
        success: true,
      };
    } else if (response.status === 200) {
      return {
        success: false,
      };
    }
  } catch (error) {
    console.log(error);
    return {
      serverError: 'Erreur serveur',
    };
  }
};
